import Paragraph from '@pelckmans/elementis/components/paragraph';
import Heading from '@pelckmans/elementis/components/heading';

function ConditionsContentFR() {
  return (
    <div className="break-word conditions-page">
      <Paragraph className="paragraph">Dernière mise à jour le 5/01/2024.</Paragraph>
      <Paragraph className="paragraph">Le présent site Internet est la propriété de :</Paragraph>
      <Paragraph className="paragraph">
        <em>
          Pelckmans éditeurs SA
          <br />
          Brasschaatsteenweg 308
          <br />
          2920 Kalmthout
          <br />
          Belgique
        </em>
      </Paragraph>
      <Paragraph className="paragraph">
        Adresse e-mail : <a href="mailto:editions@editionspelckmans.be">editions@editionspelckmans.be</a>
      </Paragraph>
      <Paragraph className="paragraph">
        Numéro d’entreprise : TVA BE 0444.548.723
        <br />
        RPM: Anvers
        <br />
        KBC Bank IBAN : BE23 4137 0045 0191
        <br />
        BIC KRED BE BB
      </Paragraph>
      <Paragraph className="paragraph">
        Les présentes conditions générales, telles qu’elles sont décrites ici, s’appliquent à tout contenu offert via la
        plate-forme d’apprentissage « p » des Pelckmans éditeurs SA. Tout enregistrement implique l’acceptation des
        conditions générales.
      </Paragraph>
      <Heading level={2} className="heading-2">
        Article 1 – Champ d’application et acceptation
      </Heading>
      <Paragraph className="paragraph">
        <b>1.1.</b> Les présentes conditions générales (« Conditions générales ») s’appliquent à l’utilisation du
        contenu (le « Contenu ») proposé sur le site Internet <a href="/">www.pelckmansportail.be</a> et les sites
        Internet, modules et applications y liés (le(s) « Site(s) Internet ») qui appartient à la S.A. PELCKMANS
        EDITEURS, ayant son siège social à 2920 Kalmthout (Belgique), Brasschaatsteenweg 308 et inscrite sous le numéro
        : 0444.548.723 et/ou aux divisions/maisons d’éditions qui en relèvent (ci-après dénommées « Pelckmans »).
      </Paragraph>
      <Paragraph className="paragraph">
        <b>1.2.</b> L’utilisateur (ci-après « Utilisateur ») est la personne physique (élève/étudiant/apprenant -
        majeure ou mineure moyennant autorisation des parents ou du tuteur -, enseignant/chargé de cours ou
        professionnel de l’enseignement) qui a créé un compte d’utilisateur sur le Site Internet et désire utiliser le
        contenu de Pelckmans. Les présentes Conditions générales sont communiquées à l’Utilisateur lors de
        l’identification sur le Site Internet. Durant la procédure d’identification, l’Utilisateur confirmera
        expressément son accord avec les Conditions générales. La finalisation de l’identification par l’Utilisateur
        vaut acceptation définitive de l’application des présentes Conditions générales aux relations entre Pelckmans et
        l’Utilisateur.
      </Paragraph>
      <Paragraph className="paragraph">
        <b>1.3.</b> Les présentes Conditions générales prévalent sur les éventuelles autres conditions de l’Utilisateur.
        En acceptant les présentes Conditions générales, l’Utilisateur renonce entièrement à l’application de ses
        propres conditions générales.
      </Paragraph>
      <Paragraph className="paragraph">
        <b>1.4.</b> Toute dérogation aux présentes Conditions générales n’est opposable que moyennant l’accord préalable
        exprès et écrit de Pelckmans.
      </Paragraph>
      <Heading level={2} className="heading-2">
        Article 2 - Le Contenu
      </Heading>
      <Paragraph className="paragraph">
        <b>2.1.</b> Le Site Internet offre du matériel didactique numérique (« le Contenu ») auquel l’Utilisateur a
        accès au moyen d’un code d’activation. L’Utilisateur reçoit un ou plusieurs codes d’activation à l’achat de
        produits déterminés de Pelckmans (pour plus d'informations :{' '}
        <a href="http://www.editionspelckmans.be" target="_blank" rel="noreferrer">
          www.editionspelckmans.be
        </a>{' '}
        ou <a href="mailto:support@editionspelckmans.be">support@editionspelckmans.be</a>)
      </Paragraph>
      <Paragraph className="paragraph">
        <b>2.2.</b> Sauf disposition contraire de l’Éditeur, un code d’activation ne peut être utilisé que par une seule
        personne. La validité du matériel didactique peut également être limitée dans le temps.
      </Paragraph>
      <Paragraph className="paragraph">
        <b>2.3.</b> L’accès au contenu est réservé aux Utilisateurs qui ont conclu un contrat d’utilisation avec
        Pelckmans en s’enregistrant sur le Site Internet et en acceptant les conditions d'utilisation.
      </Paragraph>
      <Heading level={2} className="heading-2">
        Article 3 - Droits de propriété intellectuelle
      </Heading>
      <Paragraph className="paragraph">
        <b>3.1.</b> Les Sites Internet ainsi que l’ensemble de ses composants, y compris, sans s’y limiter, les textes,
        illustrations, exercices, logos, fragments audio et vidéo et mises en page, appartiennent à Pelckmans, en ce
        compris les droits de propriété intellectuelle s’y rapportant, y compris, sans s’y limiter, les droits d’auteur,
        droits des marques, droits des modèles, droits de bases de données et autres formes de droits de propriété
        intellectuelle. Pelckmans dispose au moins d’un droit d’utilisation des composants précités. L’Utilisateur n’est
        en aucun cas autorisé à reproduire, publier ou utiliser de quelque manière que ce soit les Sites Internet ou
        certains de ses composants, sans le consentement préalable écrit de Pelckmans.
      </Paragraph>
      <Paragraph className="paragraph">
        <b>3.2.</b> Pelckmans se réserve le droit de bloquer temporairement ou définitivement l'accès au Site Internet à
        toute personne suspectée d'abus.
      </Paragraph>
      <Paragraph className="paragraph">
        <b>3.3.</b> Certains composants et applications du Site Internet permettent à l’Utilisateur d’ajouter son propre
        contenu (p. ex. marquages, annotations, photos, documents, hyperliens, etc.). Afin de garantir un bon affichage,
        l’Utilisateur concède à Pelckmans une licence illimitée, gratuite et cessible en vue de l’utilisation, de la
        reproduction, du traitement et de la communication à des tiers de ce contenu ajouté dans la mesure nécessaire
        pour offrir les services du Site Internet.
      </Paragraph>
      <Paragraph className="paragraph">
        <b>3.4.</b> Tout Utilisateur qui ajoute du contenu au Site Internet est responsable des Droits de propriété
        intellectuelle y afférents. L’Utilisateur déclare que ses actes ou que le contenu ajouté par ses soins
        n’enfreignent en aucune façon les droits de propriété intellectuelle ou tous autres droits quels qu’ils soient
        d’une quelconque autre/tierce partie. La violation par l’Utilisateur des droits de propriété intellectuelle ou
        d’autres droits de tiers ne pourra en aucun cas être imputée à Pelckmans et l’Utilisateur mettra Pelckmans à
        couvert de toute plainte ou réclamation en la matière adressée à Pelckmans.
      </Paragraph>
      <Paragraph className="paragraph">
        <b>3.5.</b> Par dérogation aux articles qui précèdent, Pelckmans précise que, en ce qui concerne les fichiers
        (illustrations, fichiers Word, vidéos, etc.) que des enseignants chargent sur le portail de Pelckmans et
        partagent le cas échéant avec l’Utilisateur, seuls les enseignants concernés peuvent faire valoir des droits de
        propriété intellectuelle par rapport à ces fichiers et assument la totale responsabilité de ce contenu.
      </Paragraph>
      <Heading level={2} className="heading-2">
        Article 4 - Responsabilité
      </Heading>
      <Paragraph className="paragraph">
        <b>4.1.</b> Sauf en cas de fraude, de faute intentionnelle ou de faute grave, la responsabilité contractuelle ou
        extracontractuelle de Pelckmans ne peut être invoquée du chef de dommages indirects, immatériels ou consécutifs
        encourus par l’Utilisateur suite à un quelconque manquement de Pelckmans dans l’exécution de ses obligations
        envers l’Utilisateur concernant le bon fonctionnement et la disponibilité du Site Internet et les informations y
        figurant.
      </Paragraph>
      <Paragraph className="paragraph">
        <b>4.2.</b> Pelckmans s’efforcera de garantir l’accessibilité des Sites Internet mais n’est pas responsable des
        éventuels dommages directs ou indirects résultant de l’inaccessibilité temporaire ou partielle ou d’autres
        manquements techniques.
      </Paragraph>
      <Paragraph className="paragraph">
        <b>4.3.</b> Le Site Internet et son contenu ont été constitués avec le plus grand soin possible. Pelckmans ne
        saurait être tenue responsable des erreurs éventuelles qui y figureraient malgré tout. Les erreurs ou lacunes
        éventuelles ne confèrent aucun droit. Pelckmans ne saurait davantage être tenue responsable des éventuels
        dommages de quelque nature qu’ils soient, directs ou indirects, encourus par l'Utilisateur suite à l'utilisation
        de ce Site Internet ou des liens y insérés.
      </Paragraph>
      <Paragraph className="paragraph">
        <b>4.4.</b> Le Site Internet peut contenir des liens vers des sites Internet de tiers, ajoutés par Pelckmans ou
        par un Utilisateur. Pelckmans n’est pas responsable du contenu, de la sécurité, des conditions générales et de
        la politique de protection de la vie privée de ces sites Internet étrangers.
      </Paragraph>
      <Paragraph className="paragraph">
        <b>4.5.</b> L’utilisateur a droit à un support technique lors de l'utilisation du Site Internet via{' '}
        <a href="mailto:support@editionspelckmans.be">support@editionspelckmans.be</a>.
      </Paragraph>
      <Heading level={2} className="heading-2">
        Article 5 - Litiges et législations applicables
      </Heading>
      <Paragraph className="paragraph">
        <b>5.1.</b> En cas de contestation des Conditions d’utilisation, seuls les tribunaux de l’arrondissement
        judiciaire d’Anvers sont compétents pour régler le litige.
      </Paragraph>
      <Paragraph className="paragraph">
        <b>5.2.</b> Le contrat entre l’Utilisateur et Pelckmans est régi par le droit belge.
      </Paragraph>
      <Heading level={2} className="heading-2">
        Article 6 - Divers
      </Heading>
      <Paragraph className="paragraph">
        <b>6.1.</b> La nullité ou l’inopposabilité d’une ou plusieurs clauses des présentes Conditions d’utilisation
        n’affecte en rien la validité des autres clauses.
      </Paragraph>
      <Paragraph className="paragraph">
        <b>6.2.</b> Le contenu des Sites Internet et des Conditions d’utilisation peut faire l’objet de modifications.
      </Paragraph>
      <Paragraph className="paragraph">
        <b>6.3.</b> Toutes les données à caractère personnel de l’Utilisateur sont traitées de manière confidentielle
        par Pelckmans conformément à sa politique de protection de la vie privée reprise ci-dessous.
      </Paragraph>
      <Heading level={3} className="heading-3">
        Protection de la vie privée
      </Heading>
      <Paragraph className="paragraph">
        <b>1.1.</b> Lorsque l’Utilisateur crée un compte d’utilisateur sur le site Internet{' '}
        <a href="/">www.pelckmansportail.be</a>, Pelckmans traite certaines données de l’Utilisateur. Dans la mesure où
        l’Utilisateur est un mineur, les parents ou les représentants légaux demeurent responsables des actes posés par
        le mineur. Le traitement des données à caractère personnel du mineur est soumis à l’autorisation d’une personne
        titulaire de la responsabilité parentale à l’égard du mineur. Cette autorisation doit être donnée explicitement
        dans le module d’identification pour la création d’un compte d’utilisateur.
      </Paragraph>
      <Paragraph className="paragraph">
        <b>1.2.</b> Les Données à caractère personnel sont traitées conformément à la politique de protection de la vie
        privée des Éditions Pelckmans SA disponible sur{' '}
        <a href="http://www.editionspelckmans.be/privacy" target="_blank" rel="noreferrer">
          www.editionspelckmans.be/privacy
        </a>
        .
      </Paragraph>
    </div>
  );
}

export default ConditionsContentFR;
